import state from "./moduleNetworkState.js";
import mutations from "./moduleNetworkMutations.js";
import actions from "./moduleNetworkActions.js";
import getters from "./moduleNetworkGetters.js";

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
